import RecentlyViewed from './stock-recently-viewed';
import { recentStorage } from '../../lib/storage';
import config from './config';

export default RecentlyViewed;

/**
 * Takes a security ticker and ticket type and attempts to add to local storage
 * @param  {String} sym security ticker
 * @example "GOOG"
 * @param  {String} securityType API-provided security classification
 * @example "STOCK"
 */
export const addToRecentlyViewed = (sym, securityType) => {

	const { maxRecent: MAX_RECENT, allowedInStorage } = config;

	// Only certain security types have been whitelisted; see component-level config
	if (!allowedInStorage[securityType]) return;

	let symbols = recentStorage.get('stocks') || [];

	// Securities should be ordered by most recently viewed first
	if (symbols[0] === sym) return;
	symbols = [sym, ...symbols];

	// Only one instance of each security should be present in the list
	if (symbols.lastIndexOf(sym)) symbols.splice(symbols.lastIndexOf(sym), 1);

	if (symbols.length > MAX_RECENT) symbols.pop();
	recentStorage.set('stocks', symbols);
};



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/stock-recently-viewed/index.js